import apiClient from './apiClient';

export interface CastWaitingLocation {
  id: number;
  user_id: number;
  name?: string | null;
  name_kana?: string | null;
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  created_at?: string;
}

export type AddCastWaitingLocationData = {
  name?: string;
  name_kana?: string;
  address?: string;
  latitude?: number | null;
  longitude?: number | null;
};

const API_URL = '/users_edit';

// キャストの待機場所一覧を取得
export const getCastWaitingLocations = async (userId: number): Promise<CastWaitingLocation[]> => {
  const res = await apiClient.get<CastWaitingLocation[]>(`${API_URL}/${userId}/waiting-locations`);
  return res.data;
};

// 待機場所を追加（座標未指定で住所があればバックエンドが補完）
export const addCastWaitingLocation = async (
  userId: number,
  data: AddCastWaitingLocationData
): Promise<CastWaitingLocation> => {
  const res = await apiClient.post<CastWaitingLocation>(`${API_URL}/${userId}/waiting-locations`, data);
  return res.data;
};

// 待機場所を削除
export const deleteCastWaitingLocation = async (userId: number, locId: number): Promise<void> => {
  await apiClient.delete(`${API_URL}/${userId}/waiting-locations/${locId}`);
};

const castWaitingLocationService = {
  getCastWaitingLocations,
  addCastWaitingLocation,
  deleteCastWaitingLocation,
};

export default castWaitingLocationService;
